const Forgetpass_img ={
    Forgetpass_image : "Images/Forget_password/forget_pass.png"
};
export default Forgetpass_img;